import { render, staticRenderFns } from "./popo-search.vue?vue&type=template&id=0ea6065c&scoped=true"
import script from "./popo-search.vue?vue&type=script&lang=js"
export * from "./popo-search.vue?vue&type=script&lang=js"
import style0 from "./popo-search.vue?vue&type=style&index=0&id=0ea6065c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea6065c",
  null
  
)

export default component.exports